import React, { useState, useEffect } from "react";
import './ServiceCard.css';
import testImage from '../../../../assets/images/packages/test.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../contexts/TranslationContext';
import arrow from '../../../../assets/images/packages/svg/arrow.svg';


const ServiceCard = ({ pageData, url,onOpenService }) => {


  const image = pageData?.service_image
    ? `${url}${encodeURI(pageData.service_image)}`
    : testImage;

  return (
    <>
      {
        <div
          className="ParentPackageCard-card-container"
          data-aos="zoom-in"
          data-aos-duration="1500"
          onClick={() => {
            onOpenService(pageData);
          }}
        >
          <div
            className="ServiceCard-card-content"
            style={{ background: `linear-gradient(0deg, rgba(0, 0, 0, 0.74) 0%, rgba(0, 0, 0, 0.00) 100%), url(${image})` }}
          >
            <div className="ParentPackageCard-overlay ServiceCardOverlay">
              <div className="serviceCardTitle">{pageData.service_name}</div>
              <div className="ServiceCardDetails">{pageData.details}</div>
            </div>

            <div className="ServiceCardText">
              <div className="ParentPackageCard-card-content-text-name ServiceNameText">
                {pageData.service_name || "Unnamed service"}
              </div>
              <img src={arrow} alt="arrow" className="ServiceArrowImage" />
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default ServiceCard;
